export class Scheduling {
    date: string;
    period: number;
}



// WEBPACK FOOTER //
// /codebuild/output/src3048926480/src/src/app/shared/models/payment/scheduling.ts